module.exports = __webpack_public_path__ + "img/lander-action-02.c1233bcc.webp";